export const getConfirmationErrorCode = state =>
  state.acceptInvitation.confirmationError
export const getLoadingError = state => state.acceptInvitation.loadingError
export const getLoaded = state => state.acceptInvitation.loaded
export const getConfirmed = state => state.acceptInvitation.confirmed
export const getName = state => state.acceptInvitation.name
export const getEmail = state => state.acceptInvitation.email
export const getIsUserActive = state => state.acceptInvitation.isUserActive
